import { ObserversBase } from "@share/program/observers/ObserversBase";
import { RealtimeMessageModel, SignalRMethod } from "@api/repositories/reatime-repository/types";
import { getMessageObjectIfSuccess } from "@api/helpers/realtimeMessageHandlers";

/**
 * Обновление количества комментариев у сессии в реальном времени
 */
export class AgendaCommentsUpdatedObserver extends ObserversBase {
    method = SignalRMethod.objectCommentsCountUpdated;

    handler(message: string) {
        const messageObject: RealtimeMessageModel | null = getMessageObjectIfSuccess(message);

        if (!messageObject) {
            return;
        }

        const { objectId, comments } = messageObject;

        if (objectId && (comments || comments === 0)) {
            this.programDataHelper.updateCommentsCount(objectId, comments);
        }
    }
}
